// extracted by mini-css-extract-plugin
export default {"wrapperBonusInfo":"BonusInfo_wrapperBonusInfo__hBvuO","img":"BonusInfo_img__QSfFQ","answer":"BonusInfo_answer__4OIn5","title":"BonusInfo_title__3Vcrs","text":"BonusInfo_text__p-u9H"};